(()=>{
 const shop=location.pathname.startsWith('/pages/')||/(^|\.)madeofmemories\.ch$/.test(location.hostname);
 const home=shop?'/':'index.html';
 const kind=path=>['/','/index.html'].includes(path)?'home':['/pages/mein-buch','/anmelden.html','/mein-buch.html'].includes(path)?'book':['/pages/buch-erstellen','/funnel.html'].includes(path)?'funnel':null;
 const safe=value=>{try{const url=new URL(value,location.href);return url.origin===location.origin&&kind(url.pathname)?url.pathname+url.search+url.hash:null}catch{return null}};
 const current=kind(location.pathname);
 if(current){try{sessionStorage.setItem('mom-help-return',location.pathname+location.search+location.hash)}catch{}}
 if(!document.querySelector('.help-back'))return;
 let target=null;try{target=safe(document.referrer)||safe(sessionStorage.getItem('mom-help-return')||'')}catch{}
 target=target||home;
 const type=kind(new URL(target,location.href).pathname);
 const label=type==='book'?'Zurück zu Mein Buch':type==='funnel'?'Zurück zu deiner Buchgestaltung':'Zurück zur Startseite';
 document.querySelectorAll('.help-back,.help-bottom-back,.help-footer a[data-return-link]').forEach(link=>{link.href=target;link.textContent=label});
})();
